import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardTitle, Form, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { resetPassword } from '../../../stores/auth/actionCreators';
import { isLoggedIn } from '../../../stores/auth/selectors';
import { isLoading } from '../../../stores/navigation/selectors';
import { RootState } from '../../../stores/store';
import FormInput from '../../common/FormInput';
import { LoadingButton } from '../../navigation/LoadingButton';

interface Props extends LocalizeContextProps, RouteComponentProps {
    id: string;
    token: string;
    loading: boolean;
    isLoggedIn: boolean;

    // tslint:disable-next-line:variable-name
    resetPassword: (id: string, token: string, new_password: string, confirm_new_password: string) => void;
}

interface State {
    new_password: string;
    confirm_new_password: string;
}

class ResetPasswordDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            confirm_new_password: '',
            new_password: '',
        };
    }

    public handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            [event.target.name]: event.target.type === 'checkbox' ?
                event.target.checked : event.target.value,
            // tslint:disable-next-line:no-any
        } as any);
    }

    // tslint:disable-next-line:no-any
    public resetPassword = (e: React.SyntheticEvent<any, Event>) => {
        e.preventDefault();
        this.props.resetPassword(
            this.props.id, this.props.token,
            this.state.new_password, this.state.confirm_new_password
        );
    }

    public render() {
        const t = this.props.translate;
        return (
            <Card>
                <CardBody>
                    <CardTitle tag="h3">{t('resetPassword.header.newPassword')}</CardTitle>
                    <Form>
                        <FormInput
                            name="new_password"
                            fullName={t('resetPassword.field.newPassword') as string}
                            value={this.state.new_password}
                            onChange={this.handleInputChange}
                            type="password"
                        />
                        <FormInput
                            name="confirm_new_password"
                            fullName={t('resetPassword.field.confirmNewPassword') as string}
                            value={this.state.confirm_new_password}
                            onChange={this.handleInputChange}
                            type="password"
                        />
                        <LoadingButton
                            fixedWidth={true}
                            color="primary"
                            className={classnames('float-right', 'save-btn', 'loginBtn')}
                            type="submit"
                            loading={this.props.loading}
                            onClick={this.resetPassword}
                            onSubmit={this.resetPassword}
                        >
                            {t('resetPassword.button.confirm')}
                        </LoadingButton>
                        {this.props.isLoggedIn === false ?
                            (
                                <Link to={{ pathname: '/login', state: { from: this.props.location } }} >
                                    {t('forgotPassword.link.backToLogin')}
                                </Link>
                            ) : (
                                <Link to={{ pathname: '/select-app', state: { from: this.props.location } }} >
                                    {t('forgotPassword.link.backToApps')}
                                </Link>
                            )
                        }
                    </Form>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoggedIn: isLoggedIn(state),
    loading: isLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    // tslint:disable-next-line:variable-name
    resetPassword: (id: string, token: string, new_password: string, confirm_new_password: string) =>
        dispatch(resetPassword(id, token, new_password, confirm_new_password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ResetPasswordDialog)));
